module.exports = __webpack_public_path__ + "static/media/Raleway-Light.ed645c2b.ttf";